
import "../../Styles/animation.css";

 function KryzenHero({
  title ,
  subtitle,
  buttonText,
  buttonLink ,
  background 
}) {
  return (
    <div className={`${background} py-6`}>


      <div className="container-xl text-center">
        {/* Dynamic Title */}
        <h1 className="fw-bold text-dark mb-3 animate-fade d-none d-lg-block d-md-block display-3 display-md-3 display-lg-2">
          {title}
        </h1>
        <h1 className="fw-bold text-dark d-lg-none d-md-none mb-3 animate-fade display-6 display-md-3 display-lg-2">
          {title}
        </h1>

        {/* Dynamic Subtitle */}
        <p
          className="fs-3 text-secondary mx-auto mb-4 animate-fade delay-1"
          style={{ maxWidth: 850 }}
        >
          {subtitle}
        </p>

        {/* Dynamic Button */}
        <a href={buttonLink}>
          <button className="btn btn-success btn-lg px-4 animate-slide-up delay-2">
            {buttonText}
          </button>
        </a>
      </div>
    </div>
  );
}

export default KryzenHero